// extracted by mini-css-extract-plugin
module.exports = {"record":"territory-domains_record___L_s2","clipboard":"territory-domains_clipboard__RITce","statusIcon":"territory-domains_statusIcon__hl8eD"};